import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'

export const getShopItem = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/shop/item'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const shopApi = {
	getShopItem: getShopItem,
}

export default shopApi
